
import React from "react";
import { Button } from "@/components/ui/button";
import { ShoppingBag } from "lucide-react";

interface CartEmptyProps {
  onClose: () => void;
}

export const CartEmpty: React.FC<CartEmptyProps> = ({ onClose }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center h-full">
      <div className="bg-muted/20 rounded-full p-6 mb-6">
        <ShoppingBag className="h-10 w-10 text-muted-foreground" />
      </div>
      <h3 className="font-medium text-lg mb-2">Your cart is empty</h3>
      <p className="text-muted-foreground text-sm max-w-xs">
        Add items to your cart to continue with checkout
      </p>
      <Button 
        variant="outline" 
        className="mt-6 shadow-sm"
        onClick={onClose}
      >
        Continue Shopping
      </Button>
    </div>
  );
};
